import type { LucideIcon } from "lucide-react";

/**
 * Nome do ícone para o host.
 *
 * O menu atravessa a fronteira como JSON, e componente React não é
 * serializável — o que viaja é o nome, que o host resolve no catálogo dele
 * (`packages/ui/src/icons.ts` do portal-multi-tenant).
 *
 * O nome sai do `displayName` que o próprio lucide grava em cada ícone
 * (`createLucideIcon` faz `Component.displayName = iconName`), convertido para
 * kebab-case. Assim, item novo em `navigation.ts` já viaja com o ícone certo:
 * não há mapa aqui para alguém esquecer de atualizar.
 *
 * O `displayName` é o nome CANÔNICO, não o alias do import — `BarChart3` chega
 * como `chart-column`. Ícone que o host não conhecer cai no genérico de lá, sem
 * quebrar o menu; é o comportamento certo para um catálogo que vive noutro
 * repositório.
 */
export function iconName(icon?: LucideIcon): string | undefined {
  const nome = icon?.displayName;
  if (!nome) return undefined;
  return nome
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
    .toLowerCase();
}
